import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=11d46cfa&scoped=true&"
var script = {}
import style0 from "./DefaultLayout.vue?vue&type=style&index=0&id=11d46cfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d46cfa",
  null
  
)

export default component.exports